import Spacer from '@/components/atoms/spacer'

const CTASpacer = () => {
  const base =
    'relative w-full px-smallMobile md:px-mediumDesktop'
  return (
    <div className={base}>
      <div className='relative w-full max-w-1440 mx-auto'>
        <Spacer />
      </div>
    </div>
  )
}

export default CTASpacer
